import React from 'react';
import { Image } from '@themesberg/react-bootstrap';

import ReactLogo from '../assets/img/technologies/loader.svg';
import { useSelector } from 'react-redux';
import { storeTypes } from 'types';

const Loader = ({ isLoad }: { isLoad?: boolean }) => {
    const loadingState = useSelector((state: storeTypes.IStore) => state);
    const isLoading =
        loadingState.loginState.isLoading ||
        loadingState.studentUpdateDataState.isLoading ||
        loadingState.eventAddState.isLoading ||
        loadingState.eventSingleShowState.isLoading ||
        isLoad;
    return (
        <div
            style={{ backgroundColor: '#333333', opacity: '0.5' }}
            className={`preloader flex-column justify-content-center align-items-center ${isLoading ? '' : 'show'}`}
        >
            <Image className="loader-element animate__animated animate__jackInTheBox" src={ReactLogo} height={100} />
        </div>
    );
};
export default Loader;
